// This file was automatically generated from appchart.dialog.ordermed.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.ordermed');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.rxList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var oList1924 = opt_data.orders;
  var oListLen1924 = oList1924.length;
  for (var oIndex1924 = 0; oIndex1924 < oListLen1924; oIndex1924++) {
    var oData1924 = oList1924[oIndex1924];
    output.append('<li class="item menuTrigger" _index="', soy.$$escapeHtml(oIndex1924), '" _type="', soy.$$escapeHtml(opt_data.type), '"><span class="frame lgFont rightIndent">', soy.$$escapeHtml(oIndex1924 + 1), '.</span><span class="lgFont">', oData1924.noteSummary, '</span><span class="remove-trigger removeDocTrigger" data-id="', soy.$$escapeHtml(oData1924.id), '"></span></li>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.unknownMed = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="alertCaution">Not a known medication in our database. <a class="add-new-med-trigger">Add a new med</a>.</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.replacedMed = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="alertCaution">Original med was replaced with preferred equivalent med.</div>');
  if (!opt_sb) return output.toString();
};
